if (!customElements.get('fr-home-review-panel')) {
  customElements.define('fr-home-review-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const rail = this.querySelector('[data-frhr-featured]');
      const featured = Array.from(rail.children);
      const previous = this.querySelector('[data-frhr-previous]');
      const next = this.querySelector('[data-frhr-next]');
      const position = this.querySelector('[data-frhr-position]');
      const details = this.querySelector('[data-frhr-all]');
      const content = this.querySelector('[data-frhr-all-content]');
      const filter = this.querySelector('[data-frhr-filter]');
      const sort = this.querySelector('[data-frhr-sort]');
      const results = this.querySelector('[data-frhr-results]');
      const reviews = Array.from(results.children);
      const back = this.querySelector('[data-frhr-page-previous]');
      const forward = this.querySelector('[data-frhr-page-next]');
      const status = this.querySelector('[data-frhr-status]');
      const empty = this.querySelector('[data-frhr-empty]');
      let index = 0;
      let page = 0;
      let filtered = [];
      const pageSize = 12;
      const railIndex = () => {
        if (featured.length < 2) return 0;
        const step = featured[1].offsetLeft - featured[0].offsetLeft;
        return step > 0 ? Math.max(0, Math.min(featured.length - 1, Math.round(rail.scrollLeft / step))) : 0;
      };
      const updateRail = () => {
        index = railIndex();
        position.textContent = `${index + 1} / ${featured.length}`;
        previous.disabled = index === 0;
        next.disabled = index >= featured.length - 1;
      };
      const move = (direction) => {
        index = Math.max(0, Math.min(featured.length - 1, railIndex() + direction));
        rail.scrollTo({ left: featured[index].offsetLeft - featured[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', updateRail, { ...options, passive: true });
      const openAll = (event) => {
        event.preventDefault();
        details.open = true;
        details.querySelector('summary').focus({ preventScroll: true });
        details.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      this.querySelectorAll('[data-frhr-open]').forEach(link => link.addEventListener('click', openAll, options));
      const render = () => {
        const start = page * pageSize;
        const shown = new Set(filtered.slice(start, start + pageSize));
        reviews.forEach(review => { review.hidden = !shown.has(review); });
        empty.hidden = filtered.length !== 0;
        const template = filtered.length === 1 ? this.dataset.statusOne : this.dataset.status;
        status.textContent = filtered.length ? template.replace('[start]', String(start + 1)).replace('[end]', String(Math.min(start + pageSize, filtered.length))).replace('[total]', String(filtered.length)) : '';
        back.disabled = page === 0;
        forward.disabled = start + pageSize >= filtered.length;
      };
      const apply = () => {
        const rating = Number(filter.value);
        filtered = reviews.filter(review => !rating || Number(review.dataset.rating) === rating);
        filtered.sort((a, b) => {
          const date = (b.dataset.date || '').localeCompare(a.dataset.date || '');
          const difference = Number(b.dataset.rating) - Number(a.dataset.rating);
          if (sort.value === 'oldest') return -date;
          if (sort.value === 'highest') return difference || date;
          if (sort.value === 'lowest') return -difference || date;
          return date;
        });
        filtered.forEach(review => results.appendChild(review));
        page = 0;
        render();
      };
      const changePage = (direction) => {
        page = Math.max(0, Math.min(Math.max(0, Math.ceil(filtered.length / pageSize) - 1), page + direction));
        render();
        content.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      filter.addEventListener('change', apply, options);
      sort.addEventListener('change', apply, options);
      back.addEventListener('click', () => changePage(-1), options);
      forward.addEventListener('click', () => changePage(1), options);
      this.resize = new ResizeObserver(updateRail);
      this.resize.observe(rail);
      apply();
      updateRail();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      delete this.dataset.ready;
    }
  });
}
